import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for France
 */
export const FrPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filtre'],
  [IPageName.bookingsPage]: ['/reservations'],
  [IPageName.bookingDetailsPage]: ['/reservations/:bookingId/details'],
  [IPageName.cancellationPage]: ['/reservations/:bookingId/cancellation'],
  [IPageName.instantAccess]: ['/acces-instantane/:affiliate'],
};
